import React from 'react'
import { Button } from '@/components/Button/Button'
import { useQuizStore } from '@/store/useQuizStore'
import { clsx } from 'clsx'

export const RadioButtons = ({ data, onNextStep }: { data: any; onNextStep: () => void }) => {
  const setSingle = useQuizStore((s) => s.setSingle)
  const currentValue = useQuizStore((s) => s.getAnswer(data.name))

  const onSelect = (value: string) => {
    if (!data?.name) return
    setSingle(data.name, value)
    onNextStep()
  }

  return (
    <div className="mt-9">
      {data?.items?.map((el: any, i: number) => {
        const value = el.title
        const active = data?.name ? currentValue === value : false
        return (
          <Button
            key={value + i}
            className={clsx(
              { '!bg-lightPrimary border-2 p-[14px]': active },
              'bg-boxBg p-4 border-0 mt-3 whitespace-normal text-left border-buttonGradient justify-start gap-1 text-text  pr-14 relative transition-all duration-200',
            )}
            onClick={(e) => {
              e.preventDefault()
              onSelect(value)
            }}
          >
            {el.icon && <img src={el.icon} alt={value} width={40} height={40} />}
            <div className="pl-3 font-semibold">
              {value}
              <p className="font-medium text-[12px] leading-[16px] text-[#101A3699]">
                {el?.description && el?.description}
              </p>
            </div>
          </Button>
        )
      })}
    </div>
  )
}
